import { FilterCollapsedState, FilterType } from '../../../app-components/filter-sort-section/types'
import { SKELETON_FILTERS } from '../../../../constants/search-result-listing'
import { FilterItemTransport, FilterTransport } from '../../../../transports/filters-configuration-transport'

/**
 * Creates a dummy filter item for skeleton loading state
 */
const createDummyFilterItem = (): FilterItemTransport => ({
    linkTitle: '',
    value: 0,
    noCrawl: false,
    views: 0,
    title: '',
    checked: false,
    count: 0,
    absoluteLink: '',
    encodedLink: '',
})

/**
 * Creates a dummy filter configuration for skeleton loading state
 */
export const createDummyFilter = (
    type: FilterType | 'populars',
    title: string,
    collapsedState: FilterCollapsedState = FilterCollapsedState.FOLD,
    itemsCount: number = SKELETON_FILTERS.FILTER_ITEMS_COUNT,
): FilterTransport => ({
    type: type as FilterType,
    title,
    items: Array.from({ length: itemsCount }, () => createDummyFilterItem()),
    itemsActive: '',
    multiple: true,
    moreOrEqual: false,
    isHorizontal: false,
    collapsedState,
})

/**
 * Creates skeleton filters configuration for loading state
 */
export const createSkeletonFiltersConfiguration = (staticData: {
    filterSection?: {
        popularFilters?: string
        propertyType?: string
    }
}) => {
    const filters: FilterTransport[] = [
        createDummyFilter(
            'populars',
            staticData.filterSection?.popularFilters || '',
            FilterCollapsedState.UNFOLD,
            SKELETON_FILTERS.POPULAR_ITEMS_COUNT,
        ),
    ]

    // Add additional filter sections
    for (let i = 0; i < SKELETON_FILTERS.FILTER_SECTIONS_COUNT; i++) {
        filters.push(createDummyFilter(FilterType.PROPERTY_TYPES, '', FilterCollapsedState.FOLD))
    }

    return {
        filters,
        clearLink: '',
        objectCount: 0,
        encodedLink: '',
        sort: [],
        mapLink: '',
    }
}
